"use strict";

var _classCallCheck = require("D:\\workspace\\forkfolio-ui\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\workspace\\forkfolio-ui\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NetworkMonitor = /*#__PURE__*/function () {
  function NetworkMonitor() {
    var _this = this;

    _classCallCheck(this, NetworkMonitor);

    this._eventEmitters = [];

    if (typeof window !== "undefined" && typeof window.addEventListener !== "undefined") {
      window.addEventListener("online", function () {
        return _this.trigger("online");
      });
      window.addEventListener("offline", function () {
        return _this.trigger("offline");
      });
    }
  }

  _createClass(NetworkMonitor, [{
    key: "on",
    value: function on(event, callback) {
      this._eventEmitters.push({
        event: event,
        callback: callback
      });
    }
  }, {
    key: "trigger",
    value: function trigger(event) {
      var eventEmitters = [];

      if (event) {
        eventEmitters = this._eventEmitters.filter(function (eventEmitter) {
          return eventEmitter.event === event;
        });
      }

      eventEmitters.forEach(function (eventEmitter) {
        eventEmitter.callback();
      });
    }
  }]);

  return NetworkMonitor;
}();

exports.default = NetworkMonitor;